import Input, { InputType } from 'components/shared/inputs/input'
import useTranslation from 'utils/hooks/useTranslation'
import * as dd from 'constants/dropdown'
import { convertToSelect } from 'utils'
import { useAppSelector } from 'store/hooks'
import { useDispatch } from 'react-redux'
import type { FieldValues, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import Radio from 'components/shared/inputs/radio'
import { useCallback, useEffect } from 'react'

type HeatModeDeperditionsConnuesProps = {
  control: any
  errors: any
  deperditions: any
  touched: any
  onBlur: any
  calculateDeperd: () => void
  watch: UseFormWatch<any>
  setValue: UseFormSetValue<any>
  onSelect?: (name: keyof FieldValues, code?: string, label?: string) => void
}

const HeatModeDeperditionsCoef: React.FC<HeatModeDeperditionsConnuesProps> = (props) => {
  const [temp, year, walls, roofing, windows] = props.watch([
    'heatMode.deperditions.temperature',
    'heatMode.deperditions.year',
    'heatMode.deperditions.walls',
    'heatMode.deperditions.roofing',
    'heatMode.deperditions.windows',
  ]) //NOSONAR

  const data = {
    insulationWork: convertToSelect(dd.insulationWork),
    walls: convertToSelect(dd.insulation),
    roofing: convertToSelect(dd.insulation),
    windows: convertToSelect(dd.insulation),
    temperatures: convertToSelect(dd.temperature),
  }

  const { t } = useTranslation()

  const [_deperditions] = props.watch(['heatMode.deperditions'])

  useEffect(() => {
    props.calculateDeperd() //NOSONAR
  }, [temp, walls, roofing, windows]) //NOSONAR

  const onFieldChange = useCallback((name: keyof FieldValues, code: any) => {
    const insulationLabel = dd.insulation.find((item) => item.code === code)?.label;
    props.onSelect?.(name, code, insulationLabel)
  }, [])

  const onYearChange = (e: any) => {
    // props.onChange(e); // NOSONAR
    props.setValue('heatMode.deperditions.year', e, { shouldValidate: true, shouldDirty: true })

    const value = e

    if (value >= 1000) {
      props.calculateDeperd() // NOSONAR
    }
  }

  useEffect(() => {
    const defaultInsulationLabel = dd.insulation.find((item) => item.code === '1')?.label;
    !walls && props.onSelect?.('heatMode.deperditions.walls', '1', defaultInsulationLabel)
    !roofing && props.onSelect?.('heatMode.deperditions.roofing', '1', defaultInsulationLabel)
    !windows && props.onSelect?.('heatMode.deperditions.windows', '1', defaultInsulationLabel)
  }, [])

  return (
    <>
      <group data-gap="10" data-space="10" data-space-left="0" data-radius="10" data-direction="column">
        <group data-width="auto" data-direction="column" data-justify="end">
          <group data-gap="20" data-align="center" data-name="custom_option">
            <group data-width="auto" data-direction="column" data-justify="end">
              <group data-gap="10" data-space="10" data-space-left='0' data-radius="10" data-direction="column">

                <group data-gap="20">
                  <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                      type={InputType.Number}
                      control={props.control}
                      name="heatMode.deperditions.year"
                      label={`${t('CONSTRUCTION_YEAR')}`}
                      translateLabel={false}
                      onChange={onYearChange}
                      size="large"
                    //placeholder={`${t('CONSTRUCTION_YEAR')}`}
                    />
                  </group>
                </group>
                {/* 
                <group data-gap="20">
                  <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                    <text data-weight="400" data-color="main">
                      {t('HAVE_YOU_DONE_ANY_WORKS')}
                    </text>
                    <group data-gap="1" data-contain data-direction="row">
                      <group data-length="110" data-space="10">
                        <Radio
                          control={props.control}
                          name={'heatMode.deperditions.insulationWork'}
                          checked={!_deperditions.insulationWork}
                          onChange={() => onInsulationWorkChange(false)}
                          radioValue="false"
                          label={t('NO')}
                        />
                      </group>
                      <group data-length="110" data-space="10">
                        <Radio
                          control={props.control}
                          // value={value}
                          name={'heatMode.deperditions.insulationWork'}
                          onChange={() => onInsulationWorkChange(true)}
                          radioValue="true"
                          checked={_deperditions.insulationWork}
                          // onChange={() => handleFieldChange(name, value)}
                          label={t('YES')}
                        />
                      </group>
                    </group>
                  </group>
                </group> */}
                <group data-gap="20">
                  <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                      type={InputType.Select}
                      control={props.control}
                      label={`${t('WALL_INSULATION')}`}
                      translateLabel={false}
                      translateValue={true}
                      // requiredLabel={true}
                      name="heatMode.deperditions.walls"
                      options={data.walls}
                      // disabled={deperditions.insulationWork === '0'}
                      allowSearch={true}
                      size="large"
                      placeholder={`${t('WALL_INSULATION')}`}
                      disabled={!_deperditions.insulationWork}
                      onChange={(e: any) => onFieldChange("heatMode.deperditions.walls", e)}
                    />
                  </group>
                </group>
                <group data-gap="20">
                  <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                      type={InputType.Select}
                      control={props.control}
                      label={`${t('ROOFING_INSULATION')}`}
                      translateLabel={false}
                      translateValue={true}
                      // requiredLabel={true}
                      // control={control}
                      name="heatMode.deperditions.roofing"
                      options={data.roofing}
                      // disabled={deperditions.insulationWork === '0'}
                      allowSearch={true}
                      size="large"
                      placeholder={`${t('ROOFING_INSULATION')}`}
                      disabled={!_deperditions.insulationWork}
                      onChange={(e: any) => onFieldChange("heatMode.deperditions.roofing", e)}
                    />
                  </group>
                </group>
                <group data-gap="20">
                  <group data-length="autofit" data-fit="1" data-direction="column" data-size="large">
                    <Input
                      type={InputType.Select}
                      control={props.control}
                      label={`${t('WINDOW_INSULATION')}`}
                      translateLabel={false}
                      translateValue={true}
                      // requiredLabel={true}
                      name="heatMode.deperditions.windows"
                      options={data.windows}
                      // disabled={deperditions.insulationWork === '0'}
                      allowSearch={true}
                      size="large"
                      placeholder={`${t('WINDOW_INSULATION')}`}
                      disabled={!_deperditions.insulationWork}
                      onChange={(e: any) => onFieldChange("heatMode.deperditions.windows", e)}
                    />
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </>
  )
}

export default HeatModeDeperditionsCoef
